// extracted by mini-css-extract-plugin
export default {"single":"Notification_single__CV4m4","filename":"Notification_filename__OzV-4","upload_success_icon":"Notification_upload_success_icon__HRoBG"};